import { ActionKeys } from '~/actions/constants';
import { type ActionTypes } from '~/actions/index';

export type AuthState = {
  readonly error: string;
  readonly finishRegister: boolean;
  readonly isAuthenticated: boolean;
  readonly isLoading: boolean;
  readonly next: string;
  readonly sessionToken: string;
};

const initialState: AuthState = {
  error: '',
  finishRegister: false,
  isAuthenticated: false,
  isLoading: false,
  next: '',
  sessionToken: '',
};

const reducer = (state: AuthState = initialState, action: ActionTypes) => {
  switch (action.type) {
    case ActionKeys.REGISTER:
      return {
        ...state,
        isAuthenticated: false,
        isLoading: true,
      };
    case ActionKeys.REGISTER_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        isLoading: false,
        next: action.payload.next,
        sessionToken: action.payload.sessionToken,
      };
    case ActionKeys.REGISTER_ERROR:
      return {
        ...state,
        error: action.payload.error.errorMessage,
        isAuthenticated: false,
        isLoading: false,
      };
    case ActionKeys.RESET_AUTH_ERROR:
      return {
        ...state,
        error: '',
        isLoading: false,
      };
    case ActionKeys.FINISH_REGISTER:
      return {
        ...state,
        finishRegister: true,
      };
    default:
      return state;
  }
};

export default reducer;
